import React from "react";

const Badge = ({ className = "", ...props }) => {
  return (
    <span
      className={[
        "inline-flex items-center rounded-full border border-blue-200/40 bg-blue-200/15 px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.16em] text-blue-100",
        className,
      ].join(" ")}
      {...props}
    />
  );
};

export { Badge };
